import FlatFeeMilestone from "../../entities/flatFeeMilestone";

/**
 * FlatFeeMilestone actions
 *
 * Call order:
 *
 * FLATFEEMILESTONE_SAVE_QUEUE:	adds the item to the save queue
 * --> FLATFEEMILESTONE_SAVE:	modifies the state
 * --> FLATFEEMILESTONE_SAVE_SUCCESS: if all went well
 * --> FLATFEEMILESTONE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail FLATFEEMILESTONE_SAVE_QUEUE is during the call to FLATFEEMILESTONE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const FLATFEEMILESTONE_FETCH_ONE_QUEUE: any = 'FLATFEEMILESTONE_FETCH_ONE_QUEUE';
export const FLATFEEMILESTONE_FETCH_SUCCESS: any = 'FLATFEEMILESTONE_FETCH_SUCCESS';
export const FLATFEEMILESTONE_FETCH_FAILURE: any = 'FLATFEEMILESTONE_FETCH_FAILURE';
export const FLATFEEMILESTONE_FETCH_ONE_SUCCESS: any = 'FLATFEEMILESTONE_FETCH_ONE_SUCCESS';
export const FLATFEEMILESTONE_FETCH_ONE_FAILURE: any = 'FLATFEEMILESTONE_FETCH_ONE_FAILURE';

export const FLATFEEMILESTONE_SAVE: any = 'FLATFEEMILESTONE_SAVE';
export const FLATFEEMILESTONE_SAVE_QUEUE: any = 'FLATFEEMILESTONE_SAVE_QUEUE';
export const FLATFEEMILESTONE_SAVE_SUCCESS: any = 'FLATFEEMILESTONE_SAVE_SUCCESS';
export const FLATFEEMILESTONE_SAVE_FAILURE: any = 'FLATFEEMILESTONE_SAVE_FAILURE';

export const FLATFEEMILESTONE_SAVE_MANY: any = 'FLATFEEMILESTONE_SAVE_MANY';
export const FLATFEEMILESTONE_SAVE_MANY_QUEUE: any = 'FLATFEEMILESTONE_SAVE_MANY_QUEUE';
export const FLATFEEMILESTONE_SAVE_MANY_SUCCESS: any = 'FLATFEEMILESTONE_SAVE_MANY_SUCCESS';
export const FLATFEEMILESTONE_SAVE_MANY_FAILURE: any = 'FLATFEEMILESTONE_SAVE_MANY_FAILURE';

export const FLATFEEMILESTONE_REMOVE: any = 'FLATFEEMILESTONE_REMOVE';
export const FLATFEEMILESTONE_REMOVE_QUEUE: any = 'FLATFEEMILESTONE_REMOVE_QUEUE';
export const FLATFEEMILESTONE_REMOVE_SUCCESS: any = 'FLATFEEMILESTONE_REMOVE_SUCCESS';
export const FLATFEEMILESTONE_REMOVE_FAILURE: any = 'FLATFEEMILESTONE_REMOVE_FAILURE';

export const FLATFEEMILESTONE_RESTORE: any = 'FLATFEEMILESTONE_RESTORE';
export const FLATFEEMILESTONE_RESTORE_QUEUE: any = 'FLATFEEMILESTONE_RESTORE_QUEUE';
export const FLATFEEMILESTONE_RESTORE_SUCCESS: any = 'FLATFEEMILESTONE_RESTORE_SUCCESS';
export const FLATFEEMILESTONE_RESTORE_FAILURE: any = 'FLATFEEMILESTONE_RESTORE_FAILURE';

export const FLATFEEMILESTONE_RESTORE_MANY: any = 'FLATFEEMILESTONE_RESTORE_MANY';
export const FLATFEEMILESTONE_REMOVE_MANY: any = 'FLATFEEMILESTONE_REMOVE_MANY';

/* Fetch actions */
export const fetchFlatFeeMilestoneSuccess = (flatFeeMilestones: FlatFeeMilestone[], partial: boolean, lastFetch: number) => ({type: FLATFEEMILESTONE_FETCH_SUCCESS, flatFeeMilestones, partial, lastFetch});
export const fetchFlatFeeMilestoneFailure = (err: any) => {
		console.error('FlatFeeMilestoneAction: fetchFlatFeeMilestoneFailure', err);
		return {type: FLATFEEMILESTONE_FETCH_FAILURE, err};
};
export const fetchOneFlatFeeMilestoneQueue = (flatFeeMilestoneId: string) => ({type: FLATFEEMILESTONE_FETCH_ONE_QUEUE, flatFeeMilestoneId});
export const fetchOneFlatFeeMilestoneSuccess = (flatFeeMilestone: FlatFeeMilestone) => ({type: FLATFEEMILESTONE_FETCH_ONE_SUCCESS, flatFeeMilestone});
export const fetchOneFlatFeeMilestoneFailure = (id: string, err: any) => {
		console.error('FlatFeeMilestoneAction: fetchOneFlatFeeMilestoneFailure', err);
		return {type: FLATFEEMILESTONE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveFlatFeeMilestone = (flatFeeMilestone: FlatFeeMilestone) => {
    // console.debug('⮂ FLATFEEMILESTONE_SAVE action', flatFeeMilestone?.id);
    return {type: FLATFEEMILESTONE_SAVE, flatFeeMilestone};
}
export const saveFlatFeeMilestoneQueue = (flatFeeMilestone: FlatFeeMilestone, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ FLATFEEMILESTONE_SAVE_QUEUE action', flatFeeMilestone?.id);
    return {type: FLATFEEMILESTONE_SAVE_QUEUE, flatFeeMilestone, onQueued};
}
export const saveFlatFeeMilestoneSuccess = (flatFeeMilestone: FlatFeeMilestone) => {
    // console.debug('⮂ FLATFEEMILESTONE_SAVE_SUCCESS action', flatFeeMilestone?.id);
    return {type: FLATFEEMILESTONE_SAVE_SUCCESS, flatFeeMilestone};
}
export const saveFlatFeeMilestoneFailure = (flatFeeMilestone: FlatFeeMilestone, status: number, message: string) => {
    console.warn(`⮂ FLATFEEMILESTONE_SAVE_FAILURE error saving flatFeeMilestone: HTTP ${status}: ${message}`, flatFeeMilestone?.id);
    return {type: FLATFEEMILESTONE_SAVE_FAILURE, flatFeeMilestone, status, message};
};

/* SaveMany actions */
export const saveManyFlatFeeMilestones = (flatFeeMilestones: FlatFeeMilestone[]) => {
    // console.debug('⮂ FLATFEEMILESTONE_SAVE_MANY action', flatFeeMilestones?.map(flatFeeMilestone => flatFeeMilestone?.id).join(','));
    return {type: FLATFEEMILESTONE_SAVE_MANY, flatFeeMilestones};
}
export const saveManyFlatFeeMilestonesQueue = (flatFeeMilestones: FlatFeeMilestone[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ FLATFEEMILESTONE_SAVE_MANY_QUEUE action', flatFeeMilestones?.map(flatFeeMilestone => flatFeeMilestone.id).join(','));
    return {type: FLATFEEMILESTONE_SAVE_MANY_QUEUE, flatFeeMilestones, onQueued};
}

export const saveManyFlatFeeMilestonesSuccess = (flatFeeMilestones: FlatFeeMilestone[]) => {
    // console.debug('⮂ FLATFEEMILESTONE_SAVE_MANY_SUCCESS action', flatFeeMilestones?.map(flatFeeMilestone => flatFeeMilestone.id).join(','));
    return {type: FLATFEEMILESTONE_SAVE_MANY_SUCCESS, flatFeeMilestones};
}
export const saveManyFlatFeeMilestonesFailure = (flatFeeMilestones: FlatFeeMilestone[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_FLATFEEMILESTONES_FAILURE Error saving flatFeeMilestones: HTTP ${status}: ${message}`, flatFeeMilestones?.map(flatFeeMilestone => flatFeeMilestone.id).join(','));
		return {type: FLATFEEMILESTONE_SAVE_MANY_FAILURE, flatFeeMilestones, status, message};
};

/* Remove actions */
export const removeFlatFeeMilestone = (flatFeeMilestone: FlatFeeMilestone) => ({ type: FLATFEEMILESTONE_REMOVE, flatFeeMilestone });
export const removeFlatFeeMilestoneQueue = (flatFeeMilestone: FlatFeeMilestone) => ({ type: FLATFEEMILESTONE_REMOVE_QUEUE, flatFeeMilestone });
export const removeFlatFeeMilestoneSuccess = (flatFeeMilestone: FlatFeeMilestone) => ({ type: FLATFEEMILESTONE_REMOVE_SUCCESS, flatFeeMilestone });
export const removeFlatFeeMilestoneFailure = (flatFeeMilestone: FlatFeeMilestone, status: number, message: string) => {
	console.error(`Redux: removeFlatFeeMilestoneFailure Error removing flatFeeMilestone: HTTP ${status}: ${message}`);
	return ({ type: FLATFEEMILESTONE_REMOVE_FAILURE, flatFeeMilestone, status, message });
};

/* Restore actions */
export const restoreFlatFeeMilestone = (flatFeeMilestone: FlatFeeMilestone) => ({ type: FLATFEEMILESTONE_RESTORE, flatFeeMilestone });
export const restoreFlatFeeMilestoneQueue = (flatFeeMilestone: FlatFeeMilestone) => ({ type: FLATFEEMILESTONE_RESTORE_QUEUE, flatFeeMilestone });
export const restoreFlatFeeMilestoneSuccess = (flatFeeMilestone: FlatFeeMilestone) => ({ type: FLATFEEMILESTONE_RESTORE_SUCCESS, flatFeeMilestone });
export const restoreFlatFeeMilestoneFailure = (flatFeeMilestone: FlatFeeMilestone, status: number, message: string) => {
	console.error(`Redux: restoreFlatFeeMilestoneFailure Error restoring flatFeeMilestone: HTTP ${status}: ${message}`);
	return ({ type: FLATFEEMILESTONE_RESTORE_FAILURE, flatFeeMilestone, status, message });
};

/* RestoreMany actions */
export const restoreManyFlatFeeMilestones = (flatFeeMilestones: FlatFeeMilestone[]) => ({ type: FLATFEEMILESTONE_RESTORE_MANY, flatFeeMilestones });

/* RemoveMany actions */
export const removeManyFlatFeeMilestones = (flatFeeMilestones: FlatFeeMilestone[]) => ({ type: FLATFEEMILESTONE_REMOVE_MANY, flatFeeMilestones });